import React from 'react';

class Component extends React.Component {
  state = {};

  componentWillMount() {
    console.log(this.props);
    if (this.props.initial) {
      this.props.api('profile/postback');
    }
  }

  onChangeLink = (e) => {
    let value = e.target.value;
    let originalValue = this.props.postbackLink;
    if (typeof this.state.originalLink == 'undefined' || this.state.originalLink === null) {
      this.setState({ originalLink: originalValue });
    }
    let data = {
      postback_link: value,
      postback_type: this.props.postbackType
    };
    this.props.changeData(data);
  };

  changeType = (e) => {
    let value = parseInt(e.target.value);
    let originalValue = this.props.postbackType;
    if (value == originalValue) return;
    let data = {
      postback_link: this.props.postbackLink,
      postback_type: value
    };
    this.props.changeData(data);
    this.props.api('profile/edit_postback', data).then((res) => {
      if (!res || res.result != 1) {
        let data = {
          postback_link: this.props.postbackLink,
          postback_type: originalValue
        };
        this.props.changeData(data);
      }
    });
  };

  saveLink = (e) => {
    this.onChangeLink(e);
    let value = e.target.value;
    this.props
      .api('profile/edit_postback', {
        postback_link: value,
        postback_type: this.props.postbackType
      })
      .then((res) => {
        if (!res || !res.result) {
          let data = {
            postback_link: this.state.originalLink || '',
            postback_type: this.props.postbackType
          };
          this.setState({ originalLink: null });
          this.props.changeData(data);
        } else {
          this.setState({ originalLink: value });
        }
      });
  };

  formGroup = (label, content) => {
    let labelClass = typeof content == 'string' ? '' : 'col-form-label';
    let containerClass = typeof content == 'string' ? '' : 'form-group';
    return (
      <div class={'row ' + containerClass}>
        <label class={'col-sm-2 text-right ' + labelClass}>{label}</label>
        <div class='col-sm-10'>{content}</div>
      </div>
    );
  };

  render() {
    let fg = this.formGroup;
    let postbackSaleExample = 'http://mysite.com/aff_lsr?transaction_id=%%myclick%%';
    let description = `
      Hello, 
      to use our postback add myclick to our landings like this:
      https://datingsnaps.com/tinder/index2.php?wid=177000&subaffiliate=444&myclick=123

      and then save your postback link on this page like this:
      https://yourlink.com/postback?cid={myclick}&subaffiliate={subaffiliate}
      177000 being their webmaster id at cashplane, your link can also work with %% 
      like in the example above.
    `;
    return (
      <div class='box p-3'>
        {fg(
          'Method',
          <div class='btn-group'>
            <button
              class={'btn primary ' + (this.props.postbackType != 2 ? 'active' : '')}
              name='postback_type'
              value='1'
              onClick={this.changeType}
            >
              GET
            </button>
            <button
              class={'btn primary ' + (this.props.postbackType == 2 ? 'active' : '')}
              name='postback_type'
              value='2'
              onClick={this.changeType}
            >
              POST
            </button>
          </div>
        )}
        {fg(
          'Url',
          <input
            class='form-control'
            type='text'
            placeholder='postback url'
            name='postback_link'
            value={this.props.postbackLink}
            onChange={this.onChangeLink}
            onBlur={this.saveLink}
          />
        )}
        {fg('Hasoffers example', <pre class='p-1'>{postbackSaleExample}</pre>)}
        {fg(
          '',
          <div style={{ paddingVertical: 10 }}>
            <div>Hello,</div>
            <div>to use our postback add myclick to our landings like this:</div>
            <div>
              https://datingsnaps.com/tinder/index2.php?wid=177000&subaffiliate=444&myclick=123
            </div>
            <br />
            <div>and then save your postback link on this page like this:</div>
            <div>{'https://yourlink.com/postback?cid={myclick}&subaffiliate={subaffiliate}'}</div>
            <div>
              177000 being their webmaster id at cashplane, your link can also work with %%{' '}
            </div>
            <div>like in the example above.</div>
          </div>
        )}
        {fg('Params:', '')}
        {fg('{wid}', 'Webmaster id')}
        {fg('{subaffiliate}', 'Subaffiliate')}
        {fg('{offer}', 'Offer name')}
        {fg('{earnings}', 'Earnings')}
        {fg('{sale_id}', 'Sale id')}
        {fg('{myclick}', 'Custom var for some offers')}
        {fg('{agent}', 'Custom var for some offers')}
        {fg('{var1}', 'Custom var for some offers')}
        {fg('{var2}', 'Custom var for some offers')}
      </div>
    );
  }
}

import api from '../actions/api';
import setState from '../actions/state';
import { connect } from 'react-redux';

export default connect(
  function (state) {
    let apiState = state.api.profile_postback || state.api.initial;
    let editApiState = state.api.profile_edit_postback || state.api.initial;
    return {
      initial: apiState.initial,
      loading: apiState.loading,
      postbackLink: apiState.data.postback_link || '',
      postbackType: parseInt(apiState.data.postback_type || 1),
      editLoading: editApiState.loading,
      state: state.state.profile || state.state.initial,
      user: state.session.user
    };
  },
  {
    api,
    setState: setState('profile'),
    changeData: function (data) {
      return function (dispatch) {
        dispatch({
          type: 'api_success',
          key: 'profile_postback',
          manual: true,
          data: data
        });
      };
    }
  }
)(Component);
